import React from 'react'
import { ARRANGEMENT_NAMES_ARRAY } from 'services/cfg/form'
import SingleArrangementInput from './SingleArrangementInput'

const LocationArrangementsInput: React.FC = () => (
  <>
    {ARRANGEMENT_NAMES_ARRAY.map((name, idx) => (
      <SingleArrangementInput name={name} key={`${idx}-${name}`} />
    ))}
  </>
)

export default LocationArrangementsInput
